import { render, staticRenderFns } from "./RecommendPost.vue?vue&type=template&id=7a0bc8f0&scoped=true&"
import script from "./RecommendPost.vue?vue&type=script&lang=js&"
export * from "./RecommendPost.vue?vue&type=script&lang=js&"
import style0 from "./RecommendPost.vue?vue&type=style&index=0&id=7a0bc8f0&lang=scss&scoped=true&"
import style1 from "./RecommendPost.vue?vue&type=style&index=1&id=7a0bc8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0bc8f0",
  null
  
)

export default component.exports